const GA_SCRIPT_ID = "olreadia-google-analytics";

let initializedMeasurementId = "";
let lastTrackedPage = "";

export const getGoogleAnalyticsMeasurementId = () =>
  (process.env.REACT_APP_GOOGLE_ANALYTICS_ID ||
    process.env.REACT_APP_GA_MEASUREMENT_ID ||
    "").trim();

export const initGoogleAnalytics = () => {
  const measurementId = getGoogleAnalyticsMeasurementId();

  if (!measurementId || typeof window === "undefined") {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!document.getElementById(GA_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
  }

  if (initializedMeasurementId !== measurementId) {
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { send_page_view: false });
    initializedMeasurementId = measurementId;
  }

  return true;
};

export const trackGoogleAnalyticsPageView = (location) => {
  const measurementId = initializedMeasurementId || getGoogleAnalyticsMeasurementId();

  if (!measurementId || typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  const pagePath = `${location?.pathname || window.location.pathname}${location?.search || window.location.search}${location?.hash || window.location.hash}`;

  if (lastTrackedPage === pagePath) {
    return;
  }

  lastTrackedPage = pagePath;
  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
};
